import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  FormControl,
  FormLabel,
  Text,
  HStack,
  VStack,
  Button,
} from "@chakra-ui/react";
import { OnChangeValue, Select } from "chakra-react-select";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { CherryHubAdminApi } from "../../api/adminApiModels";
import { PageContent } from "../../components/PageContent/PageContent";
import { PageHeading } from "../../components/PageHeading/PageHeading";
import { StatusTable } from "../../components/Report/StatusTable";
import { InvitationType, InvitationTypeList } from "../../enums/InvitationType";
import { useAdminApiClient } from "../../hooks/useApiClient";
import { useAdminApiRequest } from "../../hooks/useApiRequest";
import { sortBy } from "lodash";
import { chakraStyles } from "../../components/fields/SelectField/ChakraReactSelectField";

export const StatusReport = () => {
  type Option = { label: string; value: string | undefined };
  const [selectedBusinesses, setSelectedBusinesses] = useState<string[]>([]);
  const [invitationType, setInvitationType] = useState<string | undefined>(
    InvitationType.Pass
  );

  const apiClient = useAdminApiClient();
  const onInvitationTypeChanged = (e: OnChangeValue<Option, false>) => {
    setInvitationType(e?.value);
  };

  const { data: businesses, isLoading: businessLoading } = useAdminApiRequest(
    (client) => client.getBusinesses(),
    []
  );

  const {
    data: passStatus,
    isLoading: isLoading,
    refresh,
  } = useAdminApiRequest(
    (client) =>
      client.getCherryPassStatus({
        businessIds: selectedBusinesses.join(","),
        invitationType: invitationType as InvitationType | undefined,
      }),
    []
  );

  const onSelectBusiness = (e: readonly { label: string; value: string }[]) => {
    setSelectedBusinesses(e.map((item) => item.value));
  };

  const invitationTypeOptions: Option[] = InvitationTypeList();
  invitationTypeOptions.splice(0, 0, { label: "All", value: undefined });

  return (
    <>
      <PageHeading>
        <PageHeading.Title>Status Reports</PageHeading.Title>
      </PageHeading>
      <PageContent>
        <VStack w="100%" alignItems="flex-start">
          <Breadcrumb variant="pageHeading">
            <BreadcrumbItem>
              <BreadcrumbLink as={Link} to="/admin/reports">
                Reports
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <BreadcrumbLink as={Link} to="/admin/reports/status">
                Status Reports
              </BreadcrumbLink>
            </BreadcrumbItem>
          </Breadcrumb>

          <Text as="h2" fontSize="lg" fontWeight="bold" color="cherryUi.600">
            Reporting Filter:
          </Text>
          <HStack mt={4} w="100%" spacing={6}>
            <FormControl flex={1}>
              <FormLabel>By Invitation Type</FormLabel>
              <Select
                defaultValue={invitationTypeOptions.find(
                  (type) => type.value == InvitationType.Pass
                )}
                chakraStyles={chakraStyles}
                options={invitationTypeOptions}
                placeholder="Select invitation type"
                onChange={onInvitationTypeChanged}
              />
            </FormControl>

            <FormControl flex={4}>
              <FormLabel>By Business</FormLabel>
              <Select
                isMulti
                options={
                  businesses?.Results.map((item) => {
                    return {
                      label: item.DisplayName!,
                      value: item.Meta!.Id!,
                    };
                  }) || []
                }
                chakraStyles={chakraStyles}
                closeMenuOnSelect={false}
                isLoading={businessLoading}
                placeholder="Select businesses"
                onChange={onSelectBusiness}
              />
            </FormControl>

            <Button
              alignSelf="flex-end"
              colorScheme="cherryButton"
              onClick={refresh}
            >
              Run
            </Button>
          </HStack>
          <StatusTable
            passStatus={sortBy(passStatus, ["BusinessName", "InvitationType"])}
            isLoading={isLoading}
          />
        </VStack>
      </PageContent>
    </>
  );
};
